import { HttpParams } from "@angular/common/http";
import { Component, ElementRef, Inject, OnInit, forwardRef } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Metric, MetricCategory, ProductModel, ThingDefinition, ThingInventoryManagementType } from "../../model";
import { AppService } from "../../service/app.service";
import { AuthenticationService } from "../../service/authentication.service";
import { MetricService } from "../../service/metric.service";
import { ProductModelService } from "../../service/product-model.service";
import { ThingDefinitionService } from "../../service/thing-definition.service";
import { CustomTableColumn, CustomTableService } from "../../shared/custom-table";
import { ListWidgetV2Component } from "../../shared/list-widget-v2/list-widget-v2.components";
import { WidgetPrintResizeCoordinatorService } from "../shared/widget-print-resize-coordinator.service";
import { ErrorUtility } from "../../utility/error-utility";

@Component({
    selector: 'metric-list-widget',
    template: require('./metric-list-widget.component.html')
})
export class MetricListWidgetComponent extends ListWidgetV2Component<Metric> implements OnInit {

    thingDefAndModels: any[];
    metrics: Metric[];
    displayedColumns: CustomTableColumn[] = [
        CustomTableService.newSimpleColumn('name', 'nameProperty', 'name').withSortField('name'),
        CustomTableService.newSimpleColumn('group', 'groupProperty', 'group').withSortField('group'),
        CustomTableService.newSimpleColumn('valueType', 'typeProperty', 'valueType').withSortField('valueType'),
        CustomTableService.newSimpleColumn('unit', 'metricUnitProperty', 'unit').withSortField('unit')
    ];
    byModel: boolean;
    productModels: ProductModel[];
    thingDefinitions: ThingDefinition[];
    selectedFilter: ThingDefinition | ProductModel;

    private userTypeParams: HttpParams;

    constructor(
        @Inject(forwardRef(() => ProductModelService)) private productModelService: ProductModelService,
        @Inject(forwardRef(() => ThingDefinitionService)) private thingDefinitionService: ThingDefinitionService,
        @Inject(forwardRef(() => MetricService)) private metricService: MetricService,
        @Inject(forwardRef(() => AuthenticationService)) authenticationService: AuthenticationService,
        @Inject(forwardRef(() => AppService)) appService: AppService,
        @Inject(forwardRef(() => MatDialog)) dialog: MatDialog,
        @Inject(forwardRef(() => ElementRef)) elementRef: ElementRef,
        @Inject(forwardRef(() => WidgetPrintResizeCoordinatorService)) coordinator: WidgetPrintResizeCoordinatorService
    ) {
        super(appService, authenticationService, null, null, dialog, null, null, elementRef, coordinator);
    }

    ngOnInit(): void {
        this.sort = ['name', 'asc'];
        this.title = this.title || 'dataDocumentationProperty';
        this.loaded = true;
        this.initFilters();
        this.userTypeParams = new HttpParams().set('userTypeId', this.authenticationService.getUser().userTypeId);
    }

    private initFilters(): void {
        this.byModel = this.authenticationService.getThingInventoryManagement() == ThingInventoryManagementType.BY_MODEL;
        if (this.byModel) {
            this.productModelService.getProductModelsAssociatedToThings().then(productModels => this.productModels = productModels);
        } else {
            this.thingDefinitionService.getThingDefinitionsAssociatedToThings().then(thingDefinitions => this.thingDefinitions = thingDefinitions);
        }
    }

    getMetricList(): void {
        if (!this.selectedFilter) {
            return;
        }
        this.loaded = false;
        const thingDefId = this.byModel ? (this.selectedFilter as ProductModel).thingDefinitionId : (this.selectedFilter as ThingDefinition).id;
        this.metricService.getPagedMetricsByThingDefinitionId(thingDefId, true, MetricCategory.ALL, this.advancedSearchBody?.key, this.pageIndex, this.pageSize, this.sort, this.userTypeParams).then(pagedList => {
            this.enrichMetricList(pagedList.content);
            this.updateElementList(pagedList);
        }).catch(err => this.error = ErrorUtility.getMessage(err));
    }

    private enrichMetricList(metrics: Metric[]): void {
        metrics.forEach(m => m['unexpandable'] = !m.description && !m.technicalDescription);
    }

    refreshList(data?: { pageIndex: number, pageSize: number, advancedSearchBody: any, sort: string[] }): void {
        this.loaded = false;
        if (data) {
            this.pageIndex = data.pageIndex;
            this.pageSize = data.pageSize;
            this.advancedSearchBody = data.advancedSearchBody;
            this.sort = data.sort;
        }
        this.getMetricList();
    }

    protected subscribeToExportServices(): void {
        // do nothing
    }

    protected goToDetail(element: Metric): void {
        // do nothing
    }

}